import { quarterNumYearFormat, shortDateFormat, shortMonthAndYearFormat } from "../../../agent-production/helpers/dataFormatters";
import { marketDynamicsTimePeriods, marketDynamicsTerms as mdt } from "../../../constants";

export const cardFields = Object.freeze({
    avgSpOp: 'spOpRatioAllProperties',
    ucMsi: 'ucMsi',
    ucAvgDom: 'ucAvgDom',
    forSaleMedianVolume: 'forSaleMedianVolume',
    forSaleUnits: 'forSaleUnits',
    forSaleVolume: 'forSaleVolume',
    spOpRatioAllProperties: 'spOpRatioAllProperties',
    soldAvgPricePerSqft: 'soldAvgPricePerSqft',
    soldMedianVolume: 'soldMedianVolume',
    soldUnits: 'soldUnits',
    soldVolume: 'soldVolume',
    ucUnits: 'ucUnits',
    ucVolume: 'ucVolume',
});

export const cardKeyFactors = Object.freeze({
    [cardFields.ucMsi]: 0.9,
    [cardFields.ucAvgDom]: 0.88,
    [cardFields.forSaleMedianVolume]: 1.08,
    [cardFields.soldMedianVolume]: 1.08,
    [cardFields.avgSpOp]: 1,
    [cardFields.soldAvgPricePerSqft]: 0.9,
    [cardFields.soldVolume]: 1.27,
    [cardFields.ucVolume]: 1.27,
    [cardFields.forSaleVolume]: 1.33,
    [cardFields.soldUnits]: 0.96,
    [cardFields.ucUnits]: 0.96,
    [cardFields.forSaleUnits]: 0.96,
});

export const formatterByTimePeriod = Object.freeze({
    [marketDynamicsTimePeriods[mdt.years3Quarterly]]: (value) => quarterNumYearFormat(value),
    [marketDynamicsTimePeriods[mdt.years2Monthly]]: (value) => shortMonthAndYearFormat(value),
    [marketDynamicsTimePeriods[mdt.years1Monthly]]: (value) => shortMonthAndYearFormat(value),
    [marketDynamicsTimePeriods[mdt.months6Weekly]]: (value) => shortDateFormat(value),
});

export const displayInfo = Object.freeze({
    noDataToDisplayMessage: 'There was no activity during one or more periods of your search, making it impossible to calculate an accurate percentage change. Please refer to the chart or table for the exact data.',
    noDataToDisplayTitle: 'No Data to Display',
});
